<template>
    <div class="report-assesment">
        <ReportsTables />
    </div>
</template>

<script>
    import ReportsTables from "@/ReportAssesments/ReportsTables.vue";  
    export default {
        name: "ReportsTable", 
        components: {
            ReportsTables
        },
        methods:{
            
        }
    }
</script>